import useCallApi from '../../utilities/axios'

export type HolidayDetail = {
    holidayID: number
    day: number
    month: number
    holidayName: {
        en: string
        th: string
    }
}

export type HolidayRequest = {
    holidayID?: number
    nameTH?: string
    nameEN?: string
    day?: number
    month?: number
}

export const useSettingHoliday = () => {
    const callApi = useCallApi()

    const getHolidaySetting = async () => {
        const { data } = await callApi.axiosGet<any>({
            url: `${process.env.REACT_APP_CU_IRB_API_URL}/setting/holiday`,
        })

        return data
    }

    const upsertHolidaySetting = async (values: HolidayRequest) => {
        const { data } = await callApi.axiosPost<any>({
            url: `${process.env.REACT_APP_CU_IRB_API_URL}/setting/holiday`,
            params: values,
        })

        return data
    }

    const deleteHolidaySetting = async (holidayId: number) => {
        const { data } = await callApi.axiosDelete<any>({
            url: `${process.env.REACT_APP_CU_IRB_API_URL}/setting/holiday/${holidayId}`,
        })

        return data
    }

    return {
        getHolidaySetting,
        upsertHolidaySetting,
        deleteHolidaySetting,
    }
}
